import { Card } from '@/components/ui/Card';
import { formatIDR, formatNumber } from '@/lib/format';
import type { PaymentMethod } from '@/types/domain';
import type { PaymentBreakdown } from '@/lib/api/reports';

const METHOD_LABELS: Record<PaymentMethod, string> = {
  cash: 'Cash',
  qris: 'QRIS',
  transfer: 'Transfer',
};

const METHOD_COLORS: Record<PaymentMethod, string> = {
  cash: 'bg-success',
  qris: 'bg-primary',
  transfer: 'bg-warning',
};

export function PaymentBreakdownChart({ breakdown }: { breakdown: PaymentBreakdown[] }) {
  if (breakdown.length === 0) {
    return (
      <Card>
        <p className="text-small text-ink-subtle">Belum ada transaksi di event ini.</p>
      </Card>
    );
  }
  const total = breakdown.reduce((s, b) => s + b.total, 0);
  return (
    <Card>
      <h3 className="text-subhead font-display font-semibold text-ink mb-4">
        Payment method breakdown
      </h3>
      <div className="space-y-4">
        {breakdown.map((b) => {
          const pct = total > 0 ? (b.total / total) * 100 : 0;
          return (
            <div key={b.method}>
              <div className="flex items-center justify-between text-small mb-1.5">
                <span className="font-medium text-ink">
                  {METHOD_LABELS[b.method] ?? b.method}
                </span>
                <span className="text-ink-subtle tabular-nums">
                  {formatIDR(b.total)} ({pct.toFixed(1)}%)
                </span>
              </div>
              <div className="h-2 rounded-full bg-line/40 overflow-hidden">
                <div
                  className={`h-full ${METHOD_COLORS[b.method] ?? 'bg-primary'} rounded-full transition-all`}
                  style={{ width: `${pct}%` }}
                />
              </div>
              <p className="text-caption text-ink-subtle mt-1">
                {formatNumber(b.count)} transaksi
              </p>
            </div>
          );
        })}
      </div>
    </Card>
  );
}
